import { render, staticRenderFns } from "./participants.vue?vue&type=template&id=af2e1144&scoped=true&"
import script from "./participants.vue?vue&type=script&lang=js&"
export * from "./participants.vue?vue&type=script&lang=js&"
import style0 from "./participants.vue?vue&type=style&index=0&id=af2e1144&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2e1144",
  null
  
)

export default component.exports